export enum MainTabEnum {
  Calculators = 'calculators',
  More = 'more',
  NetSheet = 'net-sheet',
  PropertySearch = 'property-search',
  WalkingFarm = 'walking-farm'
}

export enum MainTabBasePathEnum {
  Calculators = '/calculators',
  More = '/more',
  NetSheet = '/net-sheet',
  PropertySearch = '/property-search',
  WalkingFarm = '/walking-farm'
}
